import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import "./HomeQapex.css";
import { Arrow, Icons, QapexNav, QapexFooter, Certificate, useReveal } from "./QapexChrome";

/**
 * Pagina /certificazione-qapex: spiega come si ottiene la Certificazione Qapex Quality Assured.
 * Ci si arriva da "Scopri come ottenerla" nella home; "Richiedi un ciclo di test" riporta al form
 * della home con il servizio QA Service Provider già selezionato.
 */
export default function CertificazioneQapex() {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  useReveal(rootRef);

  return (
    <div className="qx" ref={rootRef}>
      <Icons />
      <QapexNav t={t} />

      <section className="qa cpage-top">
        <div className="glow" />
        <div className="wrap">
          <div className="cert-band reveal in">
            <div>
              <div className="eyebrow">{t("home.qa.cert.eyebrow")}</div>
              <h1>{t("home.qa.cert.title")}<br />{t("home.qa.cert.titleLine2")}</h1>
              <p className="lead">{t.rich("home.qa.cert.text", { b: (c) => <b>{c}</b> })}</p>
            </div>
            <Certificate t={t} />
          </div>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="split reveal">
            <div><div className="eyebrow">{t("home.certPage.howEyebrow")}</div><h2>{t("home.certPage.howTitle")}</h2></div>
            <p className="lead">{t("home.certPage.howLead")}</p>
          </div>
          <div className="pgrid four">
            {t("home.certPage.steps").map((s, i) => (
              <div className="pstep reveal" key={s.title}><div className="n">{i + 1}</div><h3>{s.title}</h3><p>{s.text}</p></div>
            ))}
          </div>
        </div>
      </section>

      <section className="products">
        <div className="wrap">
          <div className="center cpage-cta reveal">
            <h2>{t("home.certPage.ctaTitle")}</h2>
            <p className="lead">{t("home.certPage.ctaText")}</p>
            <Link to="/#contatti" state={{ servizio: "QA Service Provider" }} className="btn btn-dark">{t("home.certPage.cta")} <Arrow /></Link>
          </div>
        </div>
      </section>

      <QapexFooter t={t} />
    </div>
  );
}
